import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- ALL TRACKINGS -------------------- */
export const AllTrackingThunk = createAsyncThunk(
  "tracking/AllTrackingThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/admin/order-trackings/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch tracking list"
      );
    }
  }
);

/* -------------------- GET SINGLE TRACKING -------------------- */
export const GetSingleTrackingThunk = createAsyncThunk(
  "tracking/GetSingleTrackingThunk",
  async (tracking_number, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/order-trackings/view/${tracking_number}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch tracking details"
      );
    }
  }
);

/* -------------------- ADD OR UPDATE TRACKING -------------------- */
export const AddTrackingThunk = createAsyncThunk(
  "tracking/AddTrackingThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/admin/order-trackings/add-update`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to add/update tracking"
      );
    }
  }
);

/* -------------------- DELETE TRACKING -------------------- */
export const DeleteTrackingThunk = createAsyncThunk(
  "tracking/DeleteTrackingThunk",
  async (tracking_number, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/admin/order-trackings/delete`, {
        params: { tracking_number },
      });
      return {
        tracking_number,
        message: response.data?.message || "Tracking deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete tracking"
      );
    }
  }
);

/* -------------------- ADD TRACKING HISTORY -------------------- */
export const AddTrackingHistoryThunk = createAsyncThunk(
  "tracking/AddTrackingHistoryThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/admin/order-trackings/history/add`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to add tracking history"
      );
    }
  }
);

/* -------------------- DELETE TRACKING HISTORY -------------------- */
export const DeleteTrackingHistoryThunk = createAsyncThunk(
  "tracking/DeleteTrackingHistoryThunk",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/admin/order-trackings/history/delete`,{id}
      );
      return {
        id,
        message:
          response.data?.message || "Tracking history deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete tracking history"
      );
    }
  }
);
